"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadEvent = void 0;
var UploadEvent = /** @class */ (function () {
    /**
     * @param {UploadJob} target
     * @param {object?} response
     * @constructor
     * @protected
     */
    function UploadEvent(target, response) {
        if (response === void 0) { response = null; }
        this.target = target;
        this.response = response;
        this.name = '';
    }
    return UploadEvent;
}());
exports.UploadEvent = UploadEvent;
//# sourceMappingURL=upload-event.js.map